import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(id: string, putObject: Request): Promise<Optional<void>> {
	const url: string = `${SERVICEBASEURL.USER}/IdentityProvider/${id}`;
	return axios.put(url, putObject).toOptionalVoid();
}

export interface Request {
	clientId: string;
	name: string;
	clientAuthenticationRequired: boolean;
	clientSecret: string;
	openIdConnectDiscoveryUrl: string;
	propagateLogout: boolean;
	useRefreshTokenForLogout: boolean;
	mapRoles: boolean;
	roleJsonPath: string;
	iconSvgId: string | null;
	sortOrder: number;
}
